module.exports = __webpack_public_path__ + "img/video-placeholder.4e6d1439.png";